import './OverviewActivities.css';
import './OverviewWidgets.css';
import NewActivityForm from '../Forms/NewActivityForm';
import Timestamp from '../Info/Timestamp';
import classNames from 'classnames';
import moment from 'moment';
import { Button, Col, Collapse, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import {
    faAngleDown,
    faTimes,
    faFileAlt,
    faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import hasPermission from '../Shared/hasPermission';
// TODO: do a much more in depth refactor later
const OverviewActivity = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { practiceId, activityId } = useParams();
    const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState(false);

    const triggerActivitiesRefresh = useSelector(
        (state) => state.toggle.triggerActivitiesRefresh
    );

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canViewAllPractices = hasPermission('ViewAllPractices', permissions);

    useEffect(() => {
        setLoading(true);
        dispatch(actions.notes.getNotes(practiceId))
            .then((res) => setNotes(res.data))
            .finally(() => setLoading(false));
        selectActivity();
        // eslint-disable-next-line
    }, [dispatch, practiceId, triggerActivitiesRefresh]);

    const [selectedActivity, setSelectedActivity] = useState({});
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [selectedActivityId, setSelectedActivityId] = useState('');
    const [isCreatingActivity, setIsCreatingActivity] = useState(false);

    const toggleCollapse = () => {
        if (isCollapsed) {
        } else {
            setIsCreatingActivity(false);
        }
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        if (activityId) {
            let activities = (notes || []).filter((x) => x.id === activityId);
            if (activities.length > 0) {
                setSelectedActivityId(activityId);
                setSelectedActivity(activities[0]);
            }
        }
    }, [activityId, notes]);

    const renderActivityText = (note) => {
        if (note === undefined || note === null) return <></>;
        return (
            <>
                {(note.content || '').split(/\n/g).map((paragraph, index) => {
                    return <p key={index}>{paragraph}</p>;
                })}
                {note.message ? (
                    <>
                        <hr />
                        <p>Message:</p>
                    </>
                ) : (
                    <hr />
                )}
                {note?.message?.split(/\n/g).map((paragraph, index) => {
                    return <p key={index + paragraph}>{paragraph}</p>;
                })}
                {(note.attachments || []).map((a) => (
                    <div className="flex justify-content-end">
                        {/* TODO: figure out a key for these */}
                        <a
                            className="justify-content-end"
                            style={{ textDecoration: 'none' }}
                            download
                            href={a.attachmentUri}
                            target="_blank"
                            rel="noreferrer">
                            {a.contentType.startsWith('image') ? (
                                <img
                                    alt={a.fileName}
                                    className="rounded sc-shadow my-2"
                                    style={{ maxWidth: '100%' }}
                                    src={a.attachmentUri}></img>
                            ) : (
                                <div className="comment-file text-nowrap hide-overflow">
                                    <FontAwesomeIcon
                                        icon={faFileAlt}
                                        size="lg"
                                    />
                                    &emsp;{a.fileName}
                                </div>
                            )}
                        </a>
                    </div>
                ))}
            </>
        );
    };

    const selectActivity = (note) => {
        if (!note && !isCreatingActivity) setSelectedActivityId('');
        else {
            setIsCreatingActivity(false);
            if (note === undefined || note === null) {
                setSelectedActivityId('');
                setSelectedActivity({});
            } else {
                setSelectedActivity(note);
                setSelectedActivityId(note.id);
            }
        }
    };

    const renderActivitiesList = (activities) => (
        <>
            {(activities || []).map((a) => { 
                const tagNameDisplay = a.tagName || 'System Action';
                const dateDisplay = moment.unix(a.createdDate).format('M/D/YY');
                const createdByDisplay =
                    a.createdByFirstName
                        ? `${a.createdByFirstName} ${a.createdByLastName || ''}`.trim()
                        : 'System';                
                return (
                    <Link
                        key={a.id}
                        className="w-100"
                        to={`/practices/${practiceId}/activities/${a.id}`}
                        style={{ textDecoration: 'none', color: 'white' }}>
                        <Row
                            className={classNames(
                                'communication hoverable py-3 rounded my-2 mx-1',
                                {
                                    'sc-glass text-light':
                                        selectedActivityId === a.id,
                                }
                            )}
                            onClick={() => selectActivity(a)}>
                            <Col lg="3" xs="4" className="hide-overflow" title={dateDisplay}>
                                {dateDisplay}
                            </Col>
                            <Col xs="4" className="hide-overflow" title={tagNameDisplay}>
                                {tagNameDisplay}
                            </Col>
                            <Col lg="5" xs="4" className="hide-overflow" title={createdByDisplay}>
                                {createdByDisplay}
                            </Col>
                        </Row>
                    </Link>
            )})}
        </>
    );

    const toggleCreatingActivity = () => {
        dispatch(actions.notes.fetchEmptyNote());
        setIsCreatingActivity(true);
        setIsCollapsed(false);
    };

    const onNewActivityCreation = (newActivityId) => {
        history.push(`/practices/${practiceId}/activities/${newActivityId}`);
    };

    return (
        <Container sm="12" className="mb-4">
            <Row>
                <Col
                    lg="5"
                    md="6"
                    xs="12"
                    className={classNames(
                        'sc-glass shadow-right fill-height text-light',
                        {
                            'sc-rounded-left':
                                !isCollapsed &&
                                (selectedActivityId !== '' ||
                                    isCreatingActivity),
                            'sc-rounded':
                                isCollapsed ||
                                (selectedActivityId === '' &&
                                    !isCreatingActivity),
                        }
                    )}>
                    <Row className="px-2 py-3">
                        <Col xs="9">
                            <h3 onClick={toggleCollapse} className="hoverable">
                                Activities&nbsp;&nbsp;
                                <span className="hoverable py-1 rounded">
                                    <FontAwesomeIcon
                                        icon={faAngleDown}
                                        className={`hoverable rotate-animated ${
                                            isCollapsed ? `rotated` : ``
                                        }`}
                                    />
                                    &nbsp;
                                </span>
                            </h3>
                        </Col>
                        <Col xs="3" className="text-right">
                            <CreateActivityButton
                                formToggle={toggleCreatingActivity}
                                canViewAllPractices={canViewAllPractices}
                            />
                        </Col>
                    </Row>
                    <Collapse isOpen={!isCollapsed}>
                        <Row className="unselectable">
                            <Col xs="12">
                                <Row className="mx-1">
                                    <Col lg="3" xs="4">
                                        Date
                                    </Col>
                                    <Col xs="4">Tag</Col>
                                    <Col lg="5" xs="4">
                                        Author
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="unselectable supportco-list-height border-top border-light">
                            <Col xs="12">
                                {loading ? (
                                    <>
                                        <h3 className="mt-4 text-center">
                                            Loading Activities...
                                            <br />
                                            <div className="mx-auto my-3 loading-spinner spin-animate"></div>
                                        </h3>
                                    </>
                                ) : (
                                    renderActivitiesList(notes)
                                )}
                            </Col>
                        </Row>
                    </Collapse>
                </Col>
                {selectedActivityId !== '' &&
                    !isCreatingActivity &&
                    !isCollapsed && (
                        <Col
                            lg="7"
                            sm="6"
                            className="px-3 py-2 sc-glass shadow-sm sc-rounded-right">
                            <Row>
                                <Col
                                    md="11"
                                    xs="12"
                                    className="mx-auto mt-auto border-bottom border-light">
                                    <Row className="rounded-top border-bottom border-light p-2 py-3">
                                        <Col
                                            sm="12"
                                            className="d-flex justify-content-between">
                                            <span className="text-14 text-light">
                                                <Timestamp
                                                    createdId={
                                                        selectedActivity?.createdById
                                                    }
                                                    firstName={
                                                        selectedActivity?.createdByFirstName
                                                    }
                                                    lastName={
                                                        selectedActivity?.createdByLastName
                                                    }
                                                    createdDate={
                                                        selectedActivity?.createdDate
                                                    }
                                                />
                                            </span>
                                            <FontAwesomeIcon
                                                className="activity-close-button text-light hoverable"
                                                icon={faTimes}
                                                size="lg"
                                                onClick={() => selectActivity()}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="supportco-list-height">
                                        <Col sm="12" className="p-3 text-light">
                                            {renderActivityText(
                                                selectedActivity
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    )}

                {isCreatingActivity && (
                    <Col
                        lg="7"
                        sm="6"
                        className="px-3 py-2 sc-glass shadow-sm sc-rounded-right">
                        <NewActivityForm
                            practiceId={practiceId}
                            cancelCallback={() => setIsCreatingActivity(false)}
                            onComplete={onNewActivityCreation}
                        />
                    </Col>
                )}
            </Row>
        </Container>
    );
};

const CreateActivityButton = ({ formToggle, canViewAllPractices }) => {
    if (canViewAllPractices) {
        return (
            <Button
                className="rounded-circle text-primary bg-light"
                onClick={formToggle}
                title="Create a new activity">
                <FontAwesomeIcon icon={faPlus} />
            </Button>
        );
    }
    return null;
};

export default React.memo(OverviewActivity);
